import { AxiosInstance, AxiosResponse } from "axios";
import { FondCarte, ModeleCarteApiFactory } from "./swagger";

export interface IApi {
  getFondCarteByModeleCarte(ref: number): Promise<FondCarte>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const ModeleCarteApi = ModeleCarteApiFactory({}, endpoint, axiosClient);

  const getFondCarteByModeleCarte = (ref): Promise<FondCarte> =>
    new Promise((resolve, reject) => {
      ModeleCarteApi.getFondCarteByModeleCarte(ref)
        .then((response: AxiosResponse<FondCarte>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });
  return {
    getFondCarteByModeleCarte,
  };
};

export default create;
